<div class="header" [class.is-mobile]="mobileQuery.matches">
    @if (headerVisible) {
        <mat-toolbar class="toolbar mat-elevation-z6">
            @if (mobileQuery.matches) {
                <button mat-icon-button (click)="snav.toggle()" id="btn-menu-header-mobile">
                    <mat-icon>menu</mat-icon>
                </button>
            }
            @if (mobileQuery.matches) {
                <span class="spacer"></span>
            }
            @if (smallQuery.matches) {
                <app-header-logo [redirectURL]="homeURL" [width]="'fit-content'" />
            } @else {
                <app-header-logo class="logo" [redirectURL]="homeURL" [width]="widthLogo" />
            }
            <span class="spacer"></span>
            @if (!mobileQuery.matches) {
                @if (smallQuery.matches) {
                    <button
                        matIconButton
                        [routerLink]="[homeURL]"
                        routerLinkActive="router-link-active"
                        [routerLinkActiveOptions]="{ exact: true }"
                        id="btn-home-header-small"
                    >
                        <mat-icon>home</mat-icon>
                    </button>
                } @else {
                    <a
                        matButton
                        [routerLink]="[homeURL]"
                        routerLinkActive="router-link-active"
                        [routerLinkActiveOptions]="{ exact: true }"
                        class="pc-view"
                        id="btn-home-header-large"
                    >
                        @if (homeIconOutlined) {
                            <mat-icon fontSet="material-icons-outlined" aria-label="Home" class="md-icon-18"
                                >home</mat-icon
                            >
                        } @else {
                            <mat-icon aria-label="Home" class="md-icon-18">home</mat-icon>
                        }
                        HOME
                    </a>
                }
            }
            @if (!mobileQuery.matches && isFAQEnable) {
                <app-redirect
                    [idRedirect]="'faq-header-button'"
                    [matButton]="true"
                    [routerLinkURL]="['/faq']"
                    routerLinkActive="router-link-active"
                    [externalLink]="faqConfig?.externalURL || ''"
                    class="pc-view"
                >
                    <mat-icon aria-label="FAQ" class="md-icon-18">help</mat-icon>
                    FAQ
                </app-redirect>
            }
            @if (!mobileQuery.matches && showFacilityInformation) {
                <app-redirect
                    [idRedirect]="'facility-information-header-button'"
                    [matButton]="true"
                    [routerLinkURL]="['/facility-information']"
                    [externalLink]="facilityInformationURL"
                    class="pc-view"
                >
                    <mat-icon aria-label="Facility information" class="md-icon-18">info</mat-icon>
                    @if (!mediumQuery.matches) {
                        FACILITY INFORMATION
                    } @else {
                        <div>
                            <span>FACILITY</span>
                            <span>INFORMATION</span>
                        </div>
                    }
                </app-redirect>
            }
            @if (!mobileQuery.matches && isHistoryEnable) {
                <a
                    mat-button
                    [routerLink]="['/payment-history']"
                    routerLinkActive="router-link-active"
                    [routerLinkActiveOptions]="{ exact: true }"
                    class="pc-view"
                    id="btn-payment-history-header"
                >
                    <mat-icon aria-label="Payment History" class="md-icon-18">history</mat-icon>
                    @if (!mediumQuery.matches) {
                        PAYMENT HISTORY
                    } @else {
                        <div>
                            <span>PAYMENT</span>
                            <span>HISTORY</span>
                        </div>
                    }
                </a>
            }
            @if (!mobileQuery.matches && isAutoPaySubscriptionEnable) {
                <a
                    mat-button
                    [routerLink]="['/subscription']"
                    routerLinkActive="router-link-active"
                    [routerLinkActiveOptions]="{ exact: true }"
                    class="pc-view"
                    id="btn-subscription-header"
                >
                    <mat-icon aria-label="subscription" class="md-icon-18">sync</mat-icon>
                    @if (!mediumQuery.matches) {
                        ARRIVAL NOTICE/AUTOPAY HISTORY
                    } @else {
                        <div>
                            <span>ARRIVAL NOTICE</span>
                            <span>AUTOPAY HISTORY </span>
                        </div>
                    }
                </a>
            }
            @if (!mobileQuery.matches) {
                <app-header-login
                    [loginDisallowedRoutes]="loginDisallowedRoutes"
                    [administrativeLoginURL]="administrativeLoginURL"
                    [isMobile]="mobileQuery.matches"
                />
            }
            @if (!mobileQuery.matches && !showSettingsAtTheEnd) {
                <app-settings />
            }

            <app-cart [cartAllowedRoutes]="cartAllowedRoutes" [cartDisallowedRoutes]="cartDisallowedRoutes" />

            @if (!mobileQuery.matches && showSettingsAtTheEnd) {
                <app-settings [settingsButtonOutline]="settingsButtonOutline" />
            }

            <ng-content select="[optional-logo-right-side]" />
        </mat-toolbar>
    }
    <mat-sidenav-container
        class="sidenav-container"
        [style.marginTop.px]="headerVisible && mobileQuery.matches ? 56 : 0"
    >
        <mat-sidenav
            #snav
            [mode]="mobileQuery.matches ? 'over' : 'side'"
            [fixedInViewport]="mobileQuery.matches"
            fixedTopGap="56"
        >
            <mat-nav-list class="mat-nav-list">
                @if (mobileQuery.matches) {
                    <a
                        (click)="snav.toggle()"
                        mat-list-item
                        [routerLink]="[homeURL]"
                        routerLinkActive="router-link-active"
                        id="btn-home-header-mobile"
                    >
                        <mat-icon aria-label="Home" class="md-icon-18">home</mat-icon>
                        HOME
                    </a>
                }
                @if (!mobileQuery.matches && isFAQEnable) {
                    <app-redirect
                        [idRedirect]="'faq-header-button-mobile'"
                        [matListItem]="true"
                        (click)="snav.toggle()"
                        [routerLinkURL]="['/faq']"
                        [externalLink]="faqConfig?.externalURL || ''"
                    >
                        <mat-icon aria-label="FAQ" class="md-icon-18">help</mat-icon>
                        <span>FAQ</span>
                    </app-redirect>
                }
                @if (mobileQuery.matches && showFacilityInformation) {
                    <app-redirect
                        [idRedirect]="'facility-information-header-button-mobile'"
                        [matListItem]="true"
                        (click)="snav.toggle()"
                        [routerLinkURL]="['/facility-information']"
                        [externalLink]="facilityInformationURL"
                    >
                        <mat-icon aria-label="Facility information" class="md-icon-18"> info </mat-icon>
                        FACILITY INFORMATION
                    </app-redirect>
                }
                @if (mobileQuery.matches && isHistoryEnable) {
                    <a
                        (click)="snav.toggle()"
                        mat-list-item
                        [routerLink]="['/payment-history']"
                        routerLinkActive="router-link-active"
                        id="btn-payment-history-header-mobile"
                    >
                        <mat-icon aria-label="Payment History" class="md-icon-18">history</mat-icon>
                        PAYMENT HISTORY
                    </a>
                }
                @if (mobileQuery.matches && isAutoPaySubscriptionEnable) {
                    <a
                        (click)="snav.toggle()"
                        mat-list-item
                        [routerLink]="['/subscription']"
                        routerLinkActive="router-link-active"
                        id="btn-subscription-header-mobile"
                    >
                        <mat-icon aria-label="Payment History" class="md-icon-18">sync</mat-icon>
                        ARRIVAL NOTICE/AUTOPAY HISTORY
                    </a>
                }
                @if (mobileQuery.matches) {
                    <app-header-login
                        [loginDisallowedRoutes]="loginDisallowedRoutes"
                        [administrativeLoginURL]="administrativeLoginURL"
                        [isMobile]="mobileQuery.matches"
                    />
                }
                @if (mobileQuery.matches) {
                    <app-settings />
                }
            </mat-nav-list>
        </mat-sidenav>

        <mat-sidenav-content id="sidenav-content">
            @if (touBanner) {
                <div>
                    <lib-banner [banner]="touBanner" class="mt-3" />
                </div>
            }
            @if (banners.length > 0) {
                @for (banner of banners; track banner.id) {
                    <lib-banner [banner]="banner" [margin]="'0px'" />
                }
            }
            <ng-content />
        </mat-sidenav-content>
    </mat-sidenav-container>
</div>
